export default "__VITE_ASSET__mp5I_Hn___"